import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PostEditDialogComponent } from '../../components/post-edit-dialog/post-edit-dialog.component';
import { Comment, Post } from '../../interfaces/post.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SocketService } from '../../services/socket.service';
import { cloneDeep } from 'lodash';
import { UserDetailsDialogComponent } from '../user-details-dialog/user-details-dialog.component';
import { LikedUsersDialogComponent } from '../liked-users-dialog/liked-users-dialog.component';
import { CollaborationService } from '../../services/collaboration.service';
import { User } from '../../interfaces/space.interface';
import { catchError, forkJoin, lastValueFrom } from 'rxjs';
import { assetUrl } from '../../asset-url';
import { DomSanitizer } from '@angular/platform-browser';
import { C } from '@angular/cdk/keycodes';
import * as MsgReader from 'wl-msg-reader';
import { MSGFileData } from 'wl-msg-reader';
import { FileTypes, PreviewDocTypes, allowedExtensions, excludedExtensions } from '../../interfaces/referral.interface';
import { NgClass, NgStyle, DatePipe } from '@angular/common';
import { UserThumbNailComponent } from '../user-thumb-nail/user-thumb-nail.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { QuillRTEComponent } from '../quill-rte/quill-rte.component';
import { DocViewerComponent } from '../doc-viewer/doc-viewer.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';
@Component({
    selector: 'app-post-details',
    templateUrl: './post-details.component.html',
    styleUrl: './post-details.component.scss',
    imports: [NgClass, UserThumbNailComponent, MatMenuTrigger, MatMenu, MatMenuItem, MatIcon, NgStyle, QuillRTEComponent, DocViewerComponent, SpinnerComponent, DatePipe, AssetUrlPipe]
})
export class PostDetailsComponent implements OnChanges, OnInit {

  @Input() post!: Post;
  @Input() isMobileScreen!: boolean;
  @Input() isIhubScreen!: boolean;
  @Input() isPostDetailView: boolean = false;
  @Output() postDetails: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() refreshPosts: EventEmitter<Post[]> = new EventEmitter<Post[]>();
  @Output() onAddComment: EventEmitter<Post[]> = new EventEmitter<Post[]>();
  menuList: any = [];
  menuItem: any = '';
  commentMenuList: any = [];
  commentMenuItem: any = '';
  loggedInUser!: User;
  actionMenuList = [
    {
      name: "Details",
      imgUrl: "",
      icon: "info_outline",
      menuItemClasses: "details-icon",
    },
    // {
    //   name: "Star",
    //   imgUrl: "star",
    // },
    // 
    {
      name: "Edit",
      imgUrl: "pencil",
    }
  ];
  subscribeActions = {
    subscribe: {
      name: "Follow",
      imgUrl: "bell",
    },
    unsubscribe: {
      name: "UnFollow",
      imgUrl: "bell_cross",
      menuItemClasses: "icon-green"
    }
  }
  previewElement: any;
  createObjectURL!: string;
  showLoader: boolean = false;

  constructor(public dialog: MatDialog, private snackBar: MatSnackBar, public socketService: SocketService, private elementRef: ElementRef, private renderer: Renderer2, private collaborationService: CollaborationService, public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.loggedInUser = this.collaborationService.allPostSpaceDetails.user;
  }

  openActions(post: Post) {
    if (post.createdById == this.loggedInUser.id) {
      this.menuList = this.isPostDetailView ? [this.actionMenuList[1]] : this.actionMenuList;
    }
    else {
      this.menuList = [
        this.actionMenuList[0],
        post.followed ? this.subscribeActions.unsubscribe : this.subscribeActions.subscribe
      ];
    }

  }

  editCommentFunction(post: Post, message: string): any {
    const updatedPost = cloneDeep(post);
    updatedPost.text = message;
    return updatedPost;
  }

  ngOnChanges() {
    this.pullAllNecessaryDOMElements();
  }

  pullAllNecessaryDOMElements() {
    setTimeout(() => {
      this.getElements();
    })
  }

  getElements() {
    const elements = this.elementRef.nativeElement.getElementsByClassName('at-mention-span');
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      this.renderer.listen(element, 'click', () => {
        this.handleElementClick(element);
      });
    }
  }

  async openUserDetailsDialog(data: any) {
    this.dialog.open(UserDetailsDialogComponent, {
      data: {
        ...data,
        //profilePictureUrl: await lastValueFrom(this.collaborationService.getUserProfilePicture(data.createdByEmail)) 
        profilePictureUrl: assetUrl('images/user.svg')
      },
      autoFocus: false
    });
  }

  async handleElementClick(element: any) {
    const className: string[] = element.classList[1].split("--");
    if (className[0].includes("at-mention-id")) {
      this.openUserDetailsDialog({
        createdByName: className[1],
        createdByEmail: className[1]
      },);
    } else {
      let errMsg = 'Error previewing the document. Please try again after some time.';
      const lastPart = className[0]?.split('-').pop();
      let [blobId, kind] = lastPart ? lastPart.split('**') : [];
      let docName = element.innerText;
      let lastDotIndex = docName?.lastIndexOf('.');
      let extension = docName.substring(lastDotIndex + 1);
      if (!blobId) {
        this.collaborationService.displayErrorMessage({}, errMsg);
        return;
      }
      const isDoc = extension.includes(PreviewDocTypes.DOC) && !excludedExtensions.includes(extension);
      const isPpt = extension.includes(PreviewDocTypes.PPT);
      const isXls = extension.includes(PreviewDocTypes.XLS) && !excludedExtensions.includes(extension);
      const isImage = kind === 'image';

      const isValidFile = isDoc || isPpt || isXls || isImage || allowedExtensions.includes(extension);
      if (!isValidFile && !([FileTypes.NOTE, FileTypes.FOLDER].includes(kind as any))) {
        if (this.isMobileScreen) {
          this.collaborationService.displayErrorMessage(
            {},
            'Preview for this file type is not supported.',
            'warning-snackbar',
            4000,
            'warning'
          );
          return;
        }
        this.collaborationService.displayErrorMessage(
          {},
          'Preview for this file type is not supported. Please open the downloaded file to preview.',
          'warning-snackbar',
          4000,
          'warning'
        );
        this.collaborationService.showPostLoader = true;
        this.showLoader = true;
        this.downloadFile(blobId, extension, docName);
        return;
      }
      if (kind === FileTypes.FOLDER) return;

      this.collaborationService.showPostLoader = true;
      this.showLoader = true;

      if (kind === FileTypes.NOTE) {
        this.collaborationService.getNoteProperties(blobId).subscribe({
          next: (data: any) => {
            let properties = JSON.parse(data.properties);
            this.collaborationService.showPostLoader = false;
            this.showLoader = false;
            this.previewElement = {
              content: this.sanitizer.bypassSecurityTrustHtml(properties.Body),
              fileExtension: extension,
              kind,
              name: docName
            };
          },
          error: (err: any) => {
            this.collaborationService.showPostLoader = false;
            this.showLoader = false;
            this.collaborationService.displayErrorMessage(err, errMsg);
          }
        })
      }

      else {
        let isOfcFile = [PreviewDocTypes.DOC, PreviewDocTypes.PPT, PreviewDocTypes.XLS].some(ext => extension.includes(ext));
        this.collaborationService.downloadDocument(blobId, {
          "spaceId": '',
          "appId": '',
          "fileExtension": extension
        }, (isOfcFile) ? 'file-preview' : 'downloadFile').subscribe({
          next: (response: any) => {
            let blob;
            if (kind === 'image') blob = new Blob([response]);
            else if (kind === 'textfile') blob = new Blob([response], { type: 'text/plain' });
            else blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            this.createObjectURL = url;
            let previewData: any = {
              fileExtension: extension,
              blobId,
              name: docName,
              kind
            };
            previewData.blobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url + '#toolbar=0');
            previewData.blob = blob;
            if (extension === PreviewDocTypes.MSG) {
              const msgBlob = new Blob([response], { type: 'application/vnd.ms-outlook' });
              const fileReader = new FileReader();
              fileReader.onload = (e: ProgressEvent): void => {
                const arrayBuffer: ArrayBuffer = (<any>e.target).result;

                const msgReader = new MsgReader.MSGReader(arrayBuffer);
                const msg: MSGFileData = msgReader.getFileData() as MSGFileData;
                previewData.emailContent = msg;
                previewData.emailContent.body = this.sanitizer.bypassSecurityTrustHtml(previewData.emailContent.body);
                this.previewElement = previewData;
              }
              fileReader.readAsArrayBuffer(msgBlob);
            }
            else if (extension === PreviewDocTypes.CSV) {
              const reader = new FileReader();
              let csvData;
              reader.onload = (event: ProgressEvent<FileReader>) => {
                csvData = event.target?.result as string;
                this.previewElement = { ...previewData, csvData };
              };
              reader.readAsText(blob);
            }
            else {
              this.previewElement = previewData;
            }
            this.collaborationService.showPostLoader = false;
            this.showLoader = false;
          }, error: (err: any) => {
            if (this.isMobileScreen) {
              this.collaborationService.showPostLoader = false;
              this.showLoader = false;
              this.collaborationService.displayErrorMessage(err, 'Preview feature for this file is currently unavailable.');
            }
            else {
              this.collaborationService.displayErrorMessage(
                {},
                'Preview feature for this file is currently unavailable. Please open the downloaded file to preview.',
                'warning-snackbar',
                4000,
                'warning'
              );
              this.downloadFile(blobId, extension, docName);
            }
          }
        });
      }
    }

  }

  editPost(post: Post) {
    const dialogRef = this.dialog.open(PostEditDialogComponent, {
      data: post,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((res: { text: string, id: string }) => {
      if (res && post.text !== res.text) {
        this.saveEditedPost(post, res)
        //this.socketService.editPost(this.editCommentFunction(post, res));
      }
    });
  }

  saveEditedPost(post: Post, data: { text: string, id: string }) {
    this.collaborationService.editorDataModified[data.id] = false;
    const message = data.text;
    const dataObj = {
      postId: post.postId,
      appId: post.appId,
      spaceId: post.spaceId,
      text: message,
      html: message,
      userEmail: post.createdByEmail
    }
    this.collaborationService.editPost(dataObj).subscribe({
      next: (res: any) => {
        post.messageToDisplay = this.sanitizer.bypassSecurityTrustHtml(message);
        post.text = message;
        post.modifiedAt = res.data.modifiedAt;
        this.pullAllNecessaryDOMElements();
        //this.refreshPosts.emit(res.data.posts);
      },
      error: (err: any) => {
        this.collaborationService.displayErrorMessage(err, 'Error while updating the post data. Please try after some time.');
      }
    });
  }

  actionMenu(itemName: string, post: Post, index = -1) {
    switch (itemName) {
      case "Edit": this.editPost(post);
        break;
      case "Details": this.postDetails.emit();
        break;
      case "Follow": this.followOrUnFollow(post);
        break;
      case "UnFollow": this.followOrUnFollow(post);
        break;
    }
  }

  likeFunction(post: Post | Comment): any {
    const updatedPost = cloneDeep(post);
    updatedPost.numberOfLikes = updatedPost.currentUserLiked ? updatedPost.numberOfLikes - 1 : updatedPost.numberOfLikes + 1;
    updatedPost.currentUserLiked = !updatedPost.currentUserLiked;
    return updatedPost;
  }

  likePostOrCommentFunction(item: any, type?: string) {
    // this.socketService.editPost(this.likeFunction(post));
    this.collaborationService.likeOrFollow({
      entityTypeId: type ? 2 : 7,
      entityId: type ? item.commentId : item.postId,
      userId: this.loggedInUser.id,
      requestType: 'like'
    }).subscribe({
      next: (res: any) => {
        item.likedByUsers = res.data;
        item.numberOfLikes = res.data.length;
        item.like = !item.like;
        (window as any).dataLayer.push({
          event: "referral_icon_click",
          eventLabel: type === 'comment' ? 'Like Comment' : 'Like Post',
          tabName: 'Post comments',
          eventPage: "Referral Actions",
        });
      },
      error: (err: any) => {
        this.collaborationService.displayErrorMessage(err, 'Error while updating the like details. Please try after some time.');
      }
    })
  }

  likeCommentFunction(comment: Comment, post: Post,) {
    this.socketService.editComment(post.postId, this.likeFunction(comment));
  }

  commentFunction(post: Post) {
    (window as any).dataLayer.push({
      event: "referral_icon_click",
      eventLabel: 'Comment',
      tabName: 'Post comments',
      eventPage: "Referral Actions",
    });
    post.openCommentBox = !post.openCommentBox;
  }
  trackItemById(index: number, item: Post): any {
    return item.postId; // Assuming items have a unique "postId" property
  }

  trackItemByCommentId(index: number, item: Comment): any {
    return item.commentId; // Assuming items have a unique "postId" property
  }

  openCommentActions(comment: Comment) {
    this.commentMenuList = [this.actionMenuList[1]]
  }

  editComment(comment: Comment, post: Post) {
    const dialogRef = this.dialog.open(PostEditDialogComponent, {
      data: { ...comment, isComment: true },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((res: { text: string, id: string }) => {
      if (res && comment.text !== res.text) {
        this.saveEditedComment(post, comment, res);
        //this.socketService.editComment(postId, this.editCommentFunction(comment, res));
      }
    });
  }

  saveEditedComment(post: Post, comment: Comment, data: { text: string, id: string }) {
    this.collaborationService.editorDataModified[data.id] = false;
    const message = data.text;
    const dataObj = {
      postId: post.postId,
      spaceId: post.spaceId,
      text: message,
      html: message,
      appId: post.appId,
      userEmail: comment.createdByEmail,
      commentId: comment.commentId
    }
    this.collaborationService.editComment(dataObj).subscribe({
      next: (res: any) => {
        comment.messageToDisplay = this.sanitizer.bypassSecurityTrustHtml(message);
        comment.text = message;
        comment.modifiedAt = res.data.modifiedAt;
        this.pullAllNecessaryDOMElements();
        //this.refreshPosts.emit(res.data.posts);
      },
      error: (err: any) => {
        this.collaborationService.displayErrorMessage(err, 'Error while updating the comment data. Please try after some time.');
      }
    });
  }

  commentActionMenu(itemName: string, comment: Comment, post: Post) {
    if (itemName == "Edit") {
      this.editComment(comment, post)
    }
  }

  async openLikedUsersDialog(data: Post | Comment, isPost: boolean) {
    const usersWithPictures = Promise.all(
      (data.likedByUsers || []).map(async (user: any) => {
        //user.profilePictureUrl = await lastValueFrom(this.collaborationService.getUserProfilePicture( user.email));
        user.profilePictureUrl = assetUrl('images/user.svg');
        return user;
      })
    );
    this.dialog.open(LikedUsersDialogComponent, {
      data: {
        isPost: isPost,
        users: await usersWithPictures
      },
      autoFocus: false,
      width: '90vw',
      disableClose: true
    })
  }

  addComment(data: { text: string, id: string }, post: Post) {
    const text = data.text;
    this.collaborationService.addComment({
      text,
      html: text,
      appId: post.appId,
      spaceId: post.spaceId,
      userEmail: this.loggedInUser.email,
      postId: post.postId.toString()
    }).subscribe({
      next: (res: any) => {
        res.data.messageToDisplay = this.sanitizer.bypassSecurityTrustHtml(text);
        post.comments = [...post.comments, {
          ...res.data,
          //profilePictureUrl: await lastValueFrom(this.collaborationService.getUserProfilePicture(res?.data?.createdByEmail))
          profilePictureUrl: assetUrl('images/user.svg')
        }];
        const numberOfComments = post.comments.length;
        post.openCommentBox = numberOfComments > 0 ? true : false,
          post.numberOfComments = numberOfComments;
        this.onAddComment.emit(res.data.posts);
        this.collaborationService.onMessageSuccessEvent.next({ id: data.id, success: true });
        this.pullAllNecessaryDOMElements();
      },
      error: (err: any) => {
        //this.showLoader = false;
        this.collaborationService.onMessageSuccessEvent.next({ id: data.id, success: false });
        this.collaborationService.displayErrorMessage(err, 'Error while adding the comment. Please try after some time.');
      }
    });
  }

  followOrUnFollow(post: Post) {
    this.collaborationService.likeOrFollow({
      entityTypeId: 7,
      entityId: post.postId,
      userId: this.loggedInUser.id,
      requestType: 'follow'
    }, 'follow').subscribe({
      next: (res: any) => {
        post.followed = !post.followed;
      },
      error: (err: any) => {
        this.collaborationService.displayErrorMessage(err, 'Error while subscribing. Please try after some time.');
      }
    })
  }

  onPreviewClose() {
    window.URL.revokeObjectURL(this.createObjectURL);
    this.previewElement = null;
  }

  downloadFile(blobId, extension, docName) {
    this.collaborationService.downloadDocument(blobId, {
      "spaceId": '',
      "appId": '',
      "fileExtension": extension
    }, 'downloadFile').subscribe({
      next: (response: any) => {
        const blob = new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = docName;
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
        this.collaborationService.showPostLoader = false;
        this.showLoader = false;
        this.collaborationService.displaySuccessMessage('File downloaded successfully.');
      }, error: (err: any) => {
        this.collaborationService.showPostLoader = false;
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(err, 'Error downloading the file. Please try again.');
      }
    });
  }
}
